import React from "react";
import QdtComponents from "qdt-components";
import PropTypes from 'prop-types';
import { QdtContext } from "../contexts";

class QdtComponent extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
  }

  static defaultProps = {
    type: 'QdtViz',
  }

  componentDidMount() {
    const { type, props, qdtComponents } = this.props;
    qdtComponents.render(type, props, this.node);
  }

  componentWillUnmount() {
    QdtComponents.unmountQdtComponent(this.node)
  }

  render() {
    return (
      <div ref={node => this.node = node} />
    );
  }

}

export default (props) => {
  return <QdtContext.Consumer>
    {qdtComponents => <QdtComponent {...props} qdtComponents={qdtComponents} />}
  </QdtContext.Consumer>
};